import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'signup:page-title': {
    id: 'signup:page-title',
    defaultMessage: 'Welcome',
    description: 'SignUp page primary title',
  },
  'signup:page-description': {
    id: 'signup:page-description',
    defaultMessage: 'Enter your mobile phone number to proceed to sign in or sign up',
    description: 'SignUp page sub-header title/description',
  },
  'signup:phone-number-label': {
    id: 'signup:phone-number-label',
    defaultMessage: 'Phone Number',
    description: 'Phone Number text field label',
  },
  'signup:magic-link-method:page-title': {
    id: 'signup:magic-link-method:page-title',
    defaultMessage: 'We just sent a text message to {phoneNumber}',
    description: 'Wait link page: sub-header title/description',
  },
  'signup:didnt-receive-sms-question': {
    id: 'signup:didnt-receive-sms-question',
    defaultMessage: "Didn't receive the SMS?",
    description: 'Wait link page: receive sms text',
  },
  'signup:resend-magic-link:button-text': {
    id: 'signup:resend-magic-link:button-text',
    defaultMessage: 'Resend link',
    description: 'Resend magic link button text',
  },
  'signup:use-otp-method:button-text': {
    id: 'signup:use-otp-method:button-text',
    defaultMessage: 'Login via code',
    description: 'Login using OTP button text',
  },

  'signup:otp-method:sms:page-title': {
    id: 'signup:otp-method:sms:page-title',
    defaultMessage: 'We just sent a {otpLength}-digit code to {phoneNumber}',
    description: '',
  },
  'signup:otp-method:phone-call:page-title': {
    id: 'signup:otp-method:phone-call:page-title',
    defaultMessage: 'You will receive a phone call with your code at {phoneNumber}',
    description: '',
  },

  'signup:otp-method:otp-field-label': {
    id: 'signup:otp-method:otp-field-label',
    defaultMessage: 'OTP Code',
    description: 'Code page: OTP input field label',
  },

  'signup:otp-method:sms:didnt-receive-otp-question': {
    id: 'signup:otp-method:sms:didnt-receive-otp-question',
    defaultMessage: "Didn't receive the SMS?",
    description: '',
  },
  'signup:otp-method:phone-call:didnt-receive-otp-question': {
    id: 'signup:otp-method:phone-call:didnt-receive-otp-question',
    defaultMessage: "Didn't receive the Call?",
    description: '',
  },

  'signup:resend-otp:button-text:sms': {
    id: 'signup:resend-otp:button-text:sms',
    defaultMessage: 'Resend code via SMS',
    description: '',
  },
  'signup:send-otp:button-text:sms': {
    id: 'signup:send-otp:button-text:sms',
    defaultMessage: 'Get code via SMS',
    description: '',
  },
  'signup:resend-otp:button-text:phone-call': {
    id: 'signup:resend-otp:button-text:phone-call',
    defaultMessage: 'Resend code via call',
    description: '',
  },
  'signup:send-otp:button-text:phone-call': {
    id: 'signup:send-otp:button-text:phone-call',
    defaultMessage: 'Get code via call',
    description: '',
  },
  'signup:resend-otp:button-text:email': {
    id: 'signup:resend-otp:button-text:email',
    defaultMessage: 'Resend code via email',
    description: '',
  },
  'signup:send-otp:button-text:email': {
    id: 'signup:send-otp:button-text:email',
    defaultMessage: 'Get code via email',
    description: '',
  },

  'signup:use-magic-link-method:button-text': {
    id: 'signup:use-magic-link-method:button-text',
    defaultMessage: 'Login via link',
    description: 'Signup via Magic Link button text',
  },
  'signup:account-verification-title': {
    id: 'account-verification-title',
    defaultMessage: 'Account Verification',
    description: 'Title on pages for OTP input and "wait message"',
  },
  'signup:html-title': {
    id: 'signup:html-title',
    defaultMessage: 'Sign Up',
    description: 'HTML title tag for Sign Up page',
  },
  'signup:auth-message-resent': {
    id: 'signup:auth-message-resent',
    defaultMessage: 'We just sent another message.',
    description: 'Snack bar message displayed when resend pressed (same method and channel)',
  },
  'signup:change-number-link:text': {
    id: 'signup:change-number-link:text',
    defaultMessage: 'Change Number',
    description: 'Signup: change phone number link text',
  },
  'signup:sms-attempt-timeout:message': {
    id: 'signup:sms-attempt-timeout:message',
    defaultMessage: `Please wait up to {seconds} seconds before making another request`,
    description: 'Signup: message displayed when user tries to request sms before cooldown timeout ended',
  },
  'signup:incorrect-otp-entered:message': {
    id: 'signup:incorrect-otp-entered:message',
    defaultMessage: `Error: Please enter a valid code`,
    description: 'Signup: message displayed when user enters incorrect OPT or signup failed without reason',
  },
  'signUp:disclaimer:markdown': {
    id: 'signUp:disclaimer:markdown',
    defaultMessage: `By entering your phone number you agree:\\n\\n- To immediately receive an SMS with a link to access your {marketingTitle} Account\\n- After each purchase where you enter your phone number, to receive an SMS informing you of how many points you earned\\n- To periodically receive promotional messages and offers via SMS\\n\\nYou also agree to our [Terms of Service]({termsOfServiceLink}) and [Privacy Policy]({privacyPolicyLink}). Msg&Data rates may apply. This agreement is not a condition of any purchase.`,
    description: 'Markdown-formatted content on sign-up disclaimer page',
  },
  'signUp:disclaimer:personalDataShareOptOut:markdown': {
    id: 'signUp:disclaimer:personalDataShareOptOut:markdown',
    defaultMessage: `*To opt-out of the sale or sharing of your personal information, click [here]({optOutUrl})`,
    description: 'Markdown-formatted personal data sharing opt-out message on sign-up disclaimer page',
  },
  'signUp:successfullyLoggedInToastMessage': {
    id: 'signUp:successfullyLoggedInToastMessage',
    defaultMessage: 'Welcome!',
    description: 'SignUp page: displayed message when successfully logged in',
  },
  'signUp:expiredLinkMessage': {
    id: 'signUp:expiredLinkMessage',
    defaultMessage: 'This link is expired. Please enter your phone number for a new link.',
    description: 'SignUp page: displayed message when sign-up link has been expired',
  },
  'signUpWithLink:htmlTitle': {
    id: 'signUpWithLink:htmlTitle',
    defaultMessage: 'Sign Up',
    description: 'HTML title tag for Sign Up with link page',
  },
  'signUp:validation:phoneNumberValidation': {
    id: 'signUp:validation:phoneNumberValidation',
    defaultMessage: 'Invalid phone number',
    description: 'Profile page phone number validation field message',
  },
});
